import { render, staticRenderFns } from "./TodasRedesSociais.vue?vue&type=template&id=cd7f7c0c&scoped=true"
import script from "./TodasRedesSociais.vue?vue&type=script&lang=js"
export * from "./TodasRedesSociais.vue?vue&type=script&lang=js"
import style0 from "./TodasRedesSociais.vue?vue&type=style&index=0&id=cd7f7c0c&prod&lang=css"
import style1 from "./TodasRedesSociais.vue?vue&type=style&index=1&id=cd7f7c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7f7c0c",
  null
  
)

export default component.exports